import { LAUNCH_DATE } from "./launch.ts";

const ANALYTICS_URL = "https://dailyfbb.com/api/puzzle-event";
const PLAYER_KEY = "pathpuzzle.analyticsPlayerId";
const startedDates = new Set<string>();

function randomPlayerId(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(24));
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}

function playerId(): string {
  try {
    const existing = localStorage.getItem(PLAYER_KEY);
    if (existing && existing.length >= 16) return existing;
    const created = randomPlayerId();
    localStorage.setItem(PLAYER_KEY, created);
    return created;
  } catch {
    // Storage can be unavailable in a privacy-restricted iframe. A page-scoped
    // identifier still records the play without collecting personal data.
    return randomPlayerId();
  }
}

function postEvent(event: "started" | "solved", date: string, durationSeconds?: number): void {
  const body: Record<string, string | number> = { event, date, playerId: playerId() };
  if (durationSeconds !== undefined) body.durationSeconds = durationSeconds;
  void fetch(ANALYTICS_URL, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
    credentials: "omit",
    keepalive: true,
  }).catch(() => {
    // Analytics must never interrupt or slow the puzzle.
  });
}

export function dateForPuzzleDay(day: number): string {
  const date = new Date(Date.UTC(LAUNCH_DATE.year, LAUNCH_DATE.month - 1, LAUNCH_DATE.day));
  date.setUTCDate(date.getUTCDate() + day - 1);
  return date.toISOString().slice(0, 10);
}

export function recordPuzzleStarted(date: string): void {
  if (startedDates.has(date)) return;
  startedDates.add(date);
  postEvent("started", date);
}

export function recordPuzzleSolved(date: string, durationSeconds: number): void {
  startedDates.add(date);
  postEvent("solved", date, Math.max(1, Math.round(durationSeconds)));
}
